/**
 * Age calculation utilities
 *
 * Utilities for calculating age from year of birth
 */

/**
 * Calculate current age from year of birth
 *
 * @param yearOfBirth - Year of birth (e.g., 1990)
 * @returns Current age in years, or null if yearOfBirth is null/invalid
 */
export function calculateAgeFromYear(
  yearOfBirth: number | null | undefined
): number | null {
  if (yearOfBirth === null || yearOfBirth === undefined) {
    return null;
  }

  const currentYear = new Date().getFullYear();
  return currentYear - yearOfBirth;
}
